import styled from 'styled-components'
import { FlagIcon, ContactIcon } from '@pga/pga-component-library'

export const Wrapper = styled.div`
display: flex;
flex-direction: ${props => props.flexDirection || 'row'};
justify-content: ${props => props.justify || 'flex-start'};
height: 100%;
width: 100%;
padding-left: 20px;
align-items: ${props => props.align};
${props => props.mb && `margin-bottom: ${props.mb}`};
@media screen and (max-width: 767.98px) {
  padding: 15px;
}
`

export const InfoWrapper = styled.div`
display: flex;
justify-content: ${props => props.justify || 'flex-start'};
align-items: center;
margin-right: 17px;
${props => props.mb && `margin-bottom: ${props.mb}`};
padding: 10px 0;
@media screen and (max-width: 575.98px) {
  font-size: 14px;
}
`

export const TextWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-content: center;
`

export const ContentWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
flex-basis: 45%;
flex-grow: 1;
order: ${props => props.viewConfig.order ? 2 : 'auto'}
@media screen and (max-width: 767.98px) {
  flex-basis: 55%;
  order: 2;
}
`

export const Flag = styled(FlagIcon)`
  align-self: flex-start;
  cursor: auto;
`

export const Phone = styled(ContactIcon)`
svg path {
  stroke: ${props => props.theme.colors.greyBlue}
}
cursor: auto;
`

export const facilityInfo = (hit, theme) => [
  {
    id: 1,
    text: hit.name,
    facilityId: '/facility/detail/' + hit.id,
    color: theme.colors.primary
  },
  {
    id: 2,
    text: hit.address1,
    color: theme.colors.primary
  },
  {
    id: 3,
    text: hit.address2,
    color: theme.colors.primary
  }, {
    id: 4,
    text: hit.address3,
    color: theme.colors.primary
  }, {
    id: 5,
    text: hit.address4,
    color: theme.colors.primary
  }
]
